import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { InsureTabApi } from '../../services';

import LoadingComponent from '../../components/common/LoadingComponent';
import NewBenefitsCard from '../../components/policy/newBenefitsCard';
import { BoldText } from '../../components/common/Text';
import NewClaimsCard from '../../components/policy/NewClaimsCard';
import NewHelpCard from '../../components/policy/NewHelpCard';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  background: #ffffff;
  overflow: hidden;
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  background: white;
`;

const Body = styled.div`
  width: 90%;
  margin: auto;
  //margin-top: 1rem;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: stretch;
  padding-bottom: 2rem;
  overflow-x: hidden;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  align-self: stretch;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f0f3f6;
  @media (min-width: 440px) {
    display: none;
  }
`;

const Header = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const HeaderText = styled(BoldText)`
  font-size: 16px;
  text-align: center;

  font-weight: 600;
`;
const SectionHeading = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  margin-bottom: 1rem;
`;
const Session = styled.div`
  margin-top: 1rem;
  border-bottom: 2px solid #e6e9ec;
`;

class NewInsureTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      insured: false,
      opdPolicies: [],
      ipdPolicies: [],
      claims: [],
      opdWalletDetails: [],
      policyDetails: {},
      policySavings: {},
      reimbursementRequests: null,
      coiUrl: null,
      activeTabIndex: 0,
      activeTab: '',
      opdDependentWallet: [],
      dependentSelectedWallet: {},
      opdEcards: [],
      benefitsSection: [],
      newBenefitsSection: [],
      newBenefitsTitle: '',
      claimsSection: [],
      helpSection: [],
      offersSection: [],
    };
  }

  getAppropriateRoute(key, policyId, policyNo, employeeId) {
    //console.log('function is accessed');
    switch (key) {
      case 'OPD':
        return this.props.history.push(
          '/home/insure/opd-benefits?hidetabs=true',
          {
            policyId,
          }
        );
      case 'help':
        return this.props.history.push('/home/insure/faq?hidetabs=true');
      case 'GMC':
        return this.props.history.push(
          '/home/insure/ipd-benefits?hidetabs=true',
          {
            policyId,
            policyType: 'gmc',
          }
        );
      case 'GTL':
        return this.props.history.push(
          '/home/insure/ipd-benefits?hidetabs=true',
          {
            policyId,
            policyType: 'gtl',
            policyNo,
            ecode: employeeId,
          }
        );
      case 'GPA':
        return this.props.history.push(
          '/home/insure/ipd-benefits?hidetabs=true',
          {
            policyId,
            policyType: 'gpa',
            policyNo,
            ecode: employeeId,
          }
        );
      default:
        return '';
    }
  }

  fetchData = async () => {
    try {
      const { authToken } = this.props;
      const data = await InsureTabApi(authToken);
      data?.sections?.forEach((item) => {
        if (item.key === 'benefits')
          this.setState({ benefitsSection: item.cards });
        if (item.key === 'html') {
          this.setState({ newBenefitsSection: item.cards, newBenefitsTitle: item.title });
        }
        if (item.key === 'claims') this.setState({ claimsSection: item.cards });
        if (item.key === 'help') this.setState({ helpSection: item.cards });
        if (item.key === 'offers') this.setState({ offersSection: item.cards });
      });
    } catch (err) {
      console.log('err is', err);
    } finally {
      this.setState({ loading: false });
    }
  };

  componentDidMount() {
    if (this.props.loginState !== 'LOGGED_IN' || !this.props.authToken) {
      this.props.history.push('/');
    } else {
      this.fetchData();
    }
  }
  render() {
    const { benefitsSection, newBenefitsSection, newBenefitsTitle, claimsSection, helpSection, loading } = this.state;
    return (
      <OuterContainer>
        <HeaderContainer>
          <Header>
            <HeaderText>My Policies</HeaderText>
          </Header>
        </HeaderContainer>

        {!loading ? (
          <BodyContainer>
            <Body>
              <div>
                {benefitsSection?.length > 0 && (
                  <Session>
                    <SectionHeading>Benefits</SectionHeading>
                    {benefitsSection.map((item) => (
                      <NewBenefitsCard
                        key={item.policyId}
                        data={item}
                        onTap={() =>
                          this.getAppropriateRoute(
                            item.type,
                            item.policyId,
                            item.policyNo,
                            item.employeeId
                          )
                        }
                      />
                    ))}
                  </Session>
                )}

                {newBenefitsSection?.length > 0 && (
                  <Session>
                    {newBenefitsTitle && <SectionHeading>{newBenefitsTitle}</SectionHeading>}
                    {newBenefitsSection.map((item, index) => (
                      <NewBenefitsCard
                        key={index}
                        data={item}
                        onTap={() => {
                          if (item.type === 'webView' && item.redirectTo) {
                            window.location.href = item.redirectTo;
                          }
                        }}
                      />
                    ))}
                  </Session>
                )}

                {claimsSection?.length > 0 && (
                  <Session>
                    <SectionHeading>Claims</SectionHeading>
                    {claimsSection.map((item) => (
                      <NewClaimsCard
                        data={item}
                        onTap={() => this.props.history.push('/claims')}
                      />
                    ))}
                  </Session>
                )}
                {helpSection?.length > 0 && (
                  <Session>
                    <SectionHeading>Help</SectionHeading>
                    {helpSection.map((item) => (
                      <NewHelpCard
                        data={item}
                        onTap={() => this.getAppropriateRoute(item.themeKey)}
                      />
                    ))}
                  </Session>
                )}
              </div>
            </Body>
          </BodyContainer>
        ) : (
          <LoadingComponent />
        )}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  loginState: state.app.loginState,
  profileImage: state.user.profileImage,
  sponsorId: state.user.sponsorId,
  showSubscription: state.app.config.showSubscription,
  showOPD: state.app.config.showOPD,
  insured: state.app.config.insured,
  subscribed: state.app.config.subscribed,
});

export default connect(mapStateToProps)(NewInsureTab);
